import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// AMC APIs
export const amcAPI = {
  create: (data) => axios.post(`${API_URL}/amcs`, data),
  getAll: () => axios.get(`${API_URL}/amcs`),
  getById: (id) => axios.get(`${API_URL}/amcs/${id}`),
  update: (id, data) => axios.put(`${API_URL}/amcs/${id}`, data),
};

// Fund APIs
export const fundAPI = {
  create: (data) => axios.post(`${API_URL}/funds`, data),
  getAll: () => axios.get(`${API_URL}/funds`),
  getById: (id) => axios.get(`${API_URL}/funds/${id}`),
  update: (id, data) => axios.put(`${API_URL}/funds/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/funds/${id}`),
  
  // Fund classes
  createClass: (fundId, data) => axios.post(`${API_URL}/funds/${fundId}/classes`, data),
  getClasses: (fundId) => axios.get(`${API_URL}/funds/${fundId}/classes`),
  deleteClass: (fundId, classId) => axios.delete(`${API_URL}/funds/${fundId}/classes/${classId}`),
  updateClass: (fundId, classId, data) => axios.put(`${API_URL}/funds/${fundId}/classes/${classId}`, data),

  // Investment summary + export
  getInvestmentsSummary: (fundId, params = {}) => {
    const qs = new URLSearchParams();
    if (params.as_on_date) qs.append('as_on_date', params.as_on_date);
    if (params.stage) qs.append('stage', params.stage);
    return axios.get(`${API_URL}/funds/${fundId}/investments-summary?${qs.toString()}`);
  },
  exportInvestmentsSummary: (fundId, format, asOnDate, stage) => {
    const qs = new URLSearchParams({ format });
    if (asOnDate) qs.append('as_on_date', asOnDate);
    if (stage) qs.append('stage', stage);
    return axios.get(`${API_URL}/funds/${fundId}/investments-summary/export?${qs.toString()}`, { responseType: 'blob' });
  },

  // Fund NAV (Phase N)
  getNAVs: (fundId) => axios.get(`${API_URL}/funds/${fundId}/navs`),
  getNAVUnitsSnapshot: (fundId, asOnDate) =>
    axios.get(`${API_URL}/funds/${fundId}/nav-units-snapshot?as_on_date=${encodeURIComponent(asOnDate)}`),
  createNAV: (fundId, data) => axios.post(`${API_URL}/funds/${fundId}/navs`, data),
  updateNAV: (fundId, navId, data) => axios.put(`${API_URL}/funds/${fundId}/navs/${navId}`, data),
  approveNAV: (fundId, navId) => axios.post(`${API_URL}/funds/${fundId}/navs/${navId}/approve`),
  rejectNAV: (fundId, navId) => axios.post(`${API_URL}/funds/${fundId}/navs/${navId}/reject`),
  deleteNAV: (fundId, navId) => axios.delete(`${API_URL}/funds/${fundId}/navs/${navId}`),

  // Document templates
  getTemplates: (fundId) => axios.get(`${API_URL}/funds/${fundId}/document-templates`),
  getTemplate: (fundId, templateId) => axios.get(`${API_URL}/funds/${fundId}/document-templates/${templateId}`),
  createTemplate: (fundId, formData) => axios.post(`${API_URL}/funds/${fundId}/document-templates`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  updateTemplate: (fundId, templateId, data) => axios.put(`${API_URL}/funds/${fundId}/document-templates/${templateId}`, data),
  deleteTemplate: (fundId, templateId) => axios.delete(`${API_URL}/funds/${fundId}/document-templates/${templateId}`),
  downloadTemplate: (templateId) => axios.get(`${API_URL}/document-templates/${templateId}/download`, { responseType: 'blob' }),
  previewTemplate: (templateId) => axios.get(`${API_URL}/document-templates/${templateId}/preview`, { responseType: 'blob' }),

  // Mail Merge / Document Generation
  getInvestorAccountsForGeneration: (fundId) => axios.get(`${API_URL}/funds/${fundId}/investor-accounts-for-generation`),
  generateDocuments: (templateId, data) => axios.post(`${API_URL}/document-templates/${templateId}/generate`, data, { responseType: 'blob' }),

  // SOA Templates
  getSOATemplates: (fundId) => axios.get(`${API_URL}/funds/${fundId}/soa-templates`),
  getSOATemplate: (fundId, templateId) => axios.get(`${API_URL}/funds/${fundId}/soa-templates/${templateId}`),
  createSOATemplate: (fundId, data) => axios.post(`${API_URL}/funds/${fundId}/soa-templates`, data),
  updateSOATemplate: (fundId, templateId, data) => axios.put(`${API_URL}/funds/${fundId}/soa-templates/${templateId}`, data),
  deleteSOATemplate: (fundId, templateId) => axios.delete(`${API_URL}/funds/${fundId}/soa-templates/${templateId}`),
  duplicateSOATemplate: (fundId, templateId, name) => axios.post(`${API_URL}/funds/${fundId}/soa-templates/${templateId}/duplicate`, { name }),
  uploadSOALogo: (fundId, templateId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API_URL}/funds/${fundId}/soa-templates/${templateId}/upload-logo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  previewSOATemplate: (fundId, templateId) => axios.get(`${API_URL}/funds/${fundId}/soa-templates/${templateId}/preview`, { responseType: 'blob' }),

  // SOA Generation
  getAccountsForSOA: (fundId) => axios.get(`${API_URL}/funds/${fundId}/investor-accounts-for-soa`),
  generateBulkSOA: (fundId, data) => axios.post(`${API_URL}/funds/${fundId}/generate-bulk-soa`, data),
  getSOAGenerationStatus: (fundId, jobId) => axios.get(`${API_URL}/funds/${fundId}/soa-generation-status/${jobId}`),
  abortSOAGeneration: (fundId, jobId) => axios.post(`${API_URL}/funds/${fundId}/soa-generation-jobs/${jobId}/abort`),
  getSOADocuments: (fundId) => axios.get(`${API_URL}/funds/${fundId}/soa-documents`),
  downloadSOADocument: (docId) => axios.get(`${API_URL}/soa-documents/${docId}/download`, { responseType: 'blob' }),
  bulkDownloadSOA: (fundId, docIds) => axios.post(`${API_URL}/funds/${fundId}/soa-documents/bulk-download`, docIds, { responseType: 'blob' }),
  deleteSOADocument: (docId) => axios.delete(`${API_URL}/soa-documents/${docId}`),
  bulkDeleteSOA: (fundId, docIds) => axios.post(`${API_URL}/funds/${fundId}/soa-documents/bulk-delete`, docIds),
};

// Field Catalog API
export const fieldCatalogAPI = {
  getAll: (fundId) => axios.get(`${API_URL}/field-catalog${fundId ? `?fund_id=${fundId}` : ''}`),
};

// SOA Field Catalog API
export const soaFieldCatalogAPI = {
  getAll: () => axios.get(`${API_URL}/soa-field-catalog`),
};

// Drawdown Management APIs
export const drawdownAPI = {
  getAll: (fundId) => axios.get(`${API_URL}/drawdowns${fundId ? `?fund_id=${fundId}` : ''}`),
  getByFundSummary: () => axios.get(`${API_URL}/drawdowns/by-fund/summary`),
  getById: (id) => axios.get(`${API_URL}/drawdowns/${id}`),
  create: (data) => axios.post(`${API_URL}/drawdowns`, data),
  update: (id, data) => axios.put(`${API_URL}/drawdowns/${id}`, data),
  recomputeAmounts: (id) => axios.post(`${API_URL}/drawdowns/${id}/recompute-amounts`),
  delete: (id) => axios.delete(`${API_URL}/drawdowns/${id}`),
  getInvestors: (id) => axios.get(`${API_URL}/drawdowns/${id}/investors`),
  updateInvestor: (ddId, invId, data) => axios.put(`${API_URL}/drawdowns/${ddId}/investors/${invId}`, data),
  // Phase M2 — maker-checker add/delete on dd_investor rows
  submitAddInvestor: (ddId, data) => axios.post(`${API_URL}/drawdowns/${ddId}/investors`, data),
  submitDeleteInvestor: (ddId, invId) => axios.delete(`${API_URL}/drawdowns/${ddId}/investors/${invId}`),
  approveAddInvestor: (ddId, invId) => axios.post(`${API_URL}/drawdowns/${ddId}/investors/${invId}/approve-add`),
  approveDeleteInvestor: (ddId, invId) => axios.post(`${API_URL}/drawdowns/${ddId}/investors/${invId}/approve-delete`),
  rejectInvestorAction: (ddId, invId) => axios.post(`${API_URL}/drawdowns/${ddId}/investors/${invId}/reject`),
  markInvestorReviewed: (ddId, invId) => axios.post(`${API_URL}/drawdowns/${ddId}/investors/${invId}/mark-reviewed`),
  recordReceipt: (ddId, invId, data) => axios.post(`${API_URL}/drawdowns/${ddId}/investors/${invId}/record-receipt`, data),
  editReceipt: (ddId, invId, receiptId, data) => axios.put(`${API_URL}/drawdowns/${ddId}/investors/${invId}/receipts/${receiptId}`, data),
  deleteReceipt: (ddId, invId, receiptId) => axios.delete(`${API_URL}/drawdowns/${ddId}/investors/${invId}/receipts/${receiptId}`),
  getReport: (ddId, filter) => axios.get(`${API_URL}/drawdowns/${ddId}/report${filter ? `?filter=${filter}` : ''}`),
  setStatusOverride: (ddId, investorId, status) => axios.patch(
    `${API_URL}/drawdowns/${ddId}/investors/${investorId}/status-override`,
    { status },  // null clears the override and reverts to auto.
  ),
  setRemarks: (ddId, investorId, remarks) => axios.patch(
    `${API_URL}/drawdowns/${ddId}/investors/${investorId}/remarks`,
    { remarks },
  ),
  emailReport: (ddId, payload) => axios.post(`${API_URL}/drawdowns/${ddId}/report/email`, payload),
  getReportEmailDefaults: () => axios.get(`${API_URL}/drawdown-report-email-defaults`),
  setReportEmailDefaults: (payload) => axios.put(`${API_URL}/drawdown-report-email-defaults`, payload),
  getTeamMembers: () => axios.get(`${API_URL}/email-recipients`),
  // WhatsApp Report — send Drawdown Report PDF to internal team via Interakt.
  whatsappReportPreflight: (ddId) => axios.get(`${API_URL}/drawdowns/${ddId}/report/whatsapp/preflight`),
  whatsappReportSend: (ddId, payload) => axios.post(`${API_URL}/drawdowns/${ddId}/report/whatsapp`, payload),
  whatsappReportHistory: (ddId) => axios.get(`${API_URL}/drawdowns/${ddId}/report/whatsapp/history`),
  exportReport: (ddId, format, filter, extraFields = []) => {
    let url = `${API_URL}/drawdowns/${ddId}/report/export?format=${format}&filter=${filter || 'all'}`;
    if (extraFields.length > 0) url += `&extra_fields=${extraFields.join(',')}`;
    return axios.get(url, { responseType: 'blob' });
  },
  // Document generation
  getTemplates: (ddId) => axios.get(`${API_URL}/drawdowns/${ddId}/templates`),
  generateNotices: (ddId, data) => axios.post(`${API_URL}/drawdowns/${ddId}/generate-notices`, data, { timeout: 300000 }),
  getGenerationStatus: (ddId) => axios.get(`${API_URL}/drawdowns/${ddId}/generation-status`),
  abortGeneration: (ddId) => axios.post(`${API_URL}/drawdowns/${ddId}/generation-status/abort`),
  getNotices: (ddId) => axios.get(`${API_URL}/drawdowns/${ddId}/notices`),
  downloadNotice: (noticeId, format, protectedFlag = false) => axios.get(`${API_URL}/drawdown-notices/${noticeId}/download?format=${format}${protectedFlag ? '&protected=true' : ''}`, { responseType: 'blob' }),
  reviewNotice: (noticeId) => axios.put(`${API_URL}/drawdown-notices/${noticeId}/review`),
  deleteNotice: (noticeId) => axios.delete(`${API_URL}/drawdown-notices/${noticeId}`),
  bulkDownloadNotices: (ddId, format, protectedFlag = false) => axios.post(`${API_URL}/drawdowns/${ddId}/notices/bulk-download?format=${format}${protectedFlag ? '&protected=true' : ''}`, {}, { responseType: 'blob', timeout: 300000 }),
  bulkReviewNotices: (ddId, noticeIds) => axios.post(`${API_URL}/drawdowns/${ddId}/notices/bulk-review`, { notice_ids: noticeIds }),
  bulkDeleteNotices: (ddId, noticeIds) => axios.post(`${API_URL}/drawdowns/${ddId}/notices/bulk-delete`, { notice_ids: noticeIds }),
  getInvestorNotices: (investorId) => axios.get(`${API_URL}/drawdown-investors/${investorId}/notices`),
  // Maker-Checker (Phase L5)
  submitForApproval: (id) => axios.post(`${API_URL}/drawdowns/${id}/submit-for-approval`),
  approveDrawdown: (id) => axios.post(`${API_URL}/drawdowns/${id}/approve`),
  rejectDrawdown: (id, reason) => axios.post(`${API_URL}/drawdowns/${id}/reject`, { rejection_reason: reason || null }),
  approveReceipt: (ddId, invId, receiptId) => axios.post(`${API_URL}/drawdowns/${ddId}/investors/${invId}/receipts/${receiptId}/approve`),
  rejectReceipt: (ddId, invId, receiptId, reason) => axios.post(`${API_URL}/drawdowns/${ddId}/investors/${invId}/receipts/${receiptId}/reject`, { rejection_reason: reason || null }),
  bulkApproveDrawdownReceipts: (ddId) => axios.post(`${API_URL}/drawdowns/${ddId}/receipts/bulk-approve`),
  getRemarksPlaceholders: () => axios.get(`${API_URL}/drawdowns/remarks-placeholders`),
};

// Capital Call Pendency Report (Phase L5)
export const capitalCallPendencyAPI = {
  get: (fundId) => axios.get(`${API_URL}/reports/capital-call-pendency${fundId ? `?fund_id=${fundId}` : ''}`),
  export: (fundId) => axios.get(`${API_URL}/reports/capital-call-pendency/export${fundId ? `?fund_id=${fundId}` : ''}`, { responseType: 'blob' }),
  // Drill-down: drawdown-wise pendency for one (account, fund) pair.
  breakdown: (accountId, fundId) => axios.get(
    `${API_URL}/reports/capital-call-pendency/breakdown`
    + `?account_id=${encodeURIComponent(accountId)}`
    + `&fund_id=${encodeURIComponent(fundId)}`,
  ),
};

// Investor Account-wise Transactions Report
export const accountTransactionsReportAPI = {
  get: ({ fromDate, toDate, fundId } = {}) => {
    const params = new URLSearchParams();
    if (fromDate) params.append('from_date', fromDate);
    if (toDate) params.append('to_date', toDate);
    if (fundId) params.append('fund_id', fundId);
    const qs = params.toString();
    return axios.get(`${API_URL}/reports/account-transactions${qs ? `?${qs}` : ''}`);
  },
  export: ({ fromDate, toDate, fundId } = {}) => {
    const params = new URLSearchParams();
    if (fromDate) params.append('from_date', fromDate);
    if (toDate) params.append('to_date', toDate);
    if (fundId) params.append('fund_id', fundId);
    const qs = params.toString();
    return axios.get(`${API_URL}/reports/account-transactions/export${qs ? `?${qs}` : ''}`, { responseType: 'blob' });
  },
};

// Incomplete Investor Profiles Report (data-completeness audit)
export const incompleteProfilesReportAPI = {
  get: ({ maxPercent, typeFilter } = {}) => {
    const params = new URLSearchParams();
    if (maxPercent != null && maxPercent !== '') params.append('max_percent', String(maxPercent));
    if (typeFilter) params.append('type_filter', typeFilter);
    const qs = params.toString();
    return axios.get(`${API_URL}/reports/incomplete-profiles${qs ? `?${qs}` : ''}`);
  },
  export: ({ maxPercent, typeFilter } = {}) => {
    const params = new URLSearchParams();
    if (maxPercent != null && maxPercent !== '') params.append('max_percent', String(maxPercent));
    if (typeFilter) params.append('type_filter', typeFilter);
    const qs = params.toString();
    return axios.get(`${API_URL}/reports/incomplete-profiles/export${qs ? `?${qs}` : ''}`, { responseType: 'blob' });
  },
};

// Investment APIs
export const investmentAPI = {
  create: (data) => axios.post(`${API_URL}/investments`, data),
  getAll: (fundId = null) => axios.get(`${API_URL}/investments${fundId ? `?fund_id=${fundId}` : ''}`),
  getById: (id) => axios.get(`${API_URL}/investments/${id}`),
  update: (id, data) => axios.put(`${API_URL}/investments/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/investments/${id}`),
  
  // Transactions
  createTransaction: (investmentId, data) => 
    axios.post(`${API_URL}/investments/${investmentId}/transactions`, data),
  getTransactions: (investmentId) => 
    axios.get(`${API_URL}/investments/${investmentId}/transactions`),
  updateTransaction: (investmentId, transactionId, data) => 
    axios.put(`${API_URL}/investments/${investmentId}/transactions/${transactionId}`, data),
  deleteTransaction: (investmentId, transactionId) => 
    axios.delete(`${API_URL}/investments/${investmentId}/transactions/${transactionId}`),
  
  // FMV
  createFMV: (investmentId, data) => 
    axios.post(`${API_URL}/investments/${investmentId}/fmv`, data),
  getFMVRecords: (investmentId) => 
    axios.get(`${API_URL}/investments/${investmentId}/fmv`),
  updateFMV: (investmentId, fmvId, data) => 
    axios.put(`${API_URL}/investments/${investmentId}/fmv/${fmvId}`, data),
  deleteFMV: (investmentId, fmvId) => 
    axios.delete(`${API_URL}/investments/${investmentId}/fmv/${fmvId}`),
  
  // Summary
  getSummary: (investmentId, dateOfIRR = null) => 
    axios.get(`${API_URL}/investments/${investmentId}/summary${dateOfIRR ? `?date_of_irr=${dateOfIRR}` : ''}`),
  
  // Documents
  getDocuments: (investmentId) => 
    axios.get(`${API_URL}/investments/${investmentId}/documents`),
  uploadDocument: (investmentId, checklistItemId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(
      `${API_URL}/investments/${investmentId}/documents/${checklistItemId}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  },
  markDocument: (investmentId, checklistItemId, data) => 
    axios.put(`${API_URL}/investments/${investmentId}/documents/${checklistItemId}/mark`, data),
  downloadDocument: (investmentId, checklistItemId) => 
    axios.get(`${API_URL}/investments/${investmentId}/documents/${checklistItemId}/download`),
  deleteDocument: (investmentId, checklistItemId) => 
    axios.delete(`${API_URL}/investments/${investmentId}/documents/${checklistItemId}`),
  
  // Fund stages
  getFundStages: (fundId) => axios.get(`${API_URL}/funds/${fundId}/stages`),
  updateFundStages: (fundId, stages) => axios.put(`${API_URL}/funds/${fundId}/stages`, stages),
};

// Document Category APIs
export const documentAPI = {
  getCategories: (investmentId) => {
    const params = investmentId ? { investment_id: investmentId } : {};
    return axios.get(`${API_URL}/document-categories`, { params });
  },
  createCategory: (data) => axios.post(`${API_URL}/document-categories`, data),
  deleteCategory: (id) => axios.delete(`${API_URL}/document-categories/${id}`),
  
  updateCategory: (id, data) => axios.put(`${API_URL}/document-categories/${id}`, data),
  
  getItems: (categoryId, investmentId) => {
    const params = investmentId ? { investment_id: investmentId } : {};
    return axios.get(`${API_URL}/document-categories/${categoryId}/items`, { params });
  },
  createItem: (categoryId, data) => 
    axios.post(`${API_URL}/document-categories/${categoryId}/items`, data),
  updateItem: (categoryId, itemId, data) => 
    axios.put(`${API_URL}/document-categories/${categoryId}/items/${itemId}`, data),
  deleteItem: (categoryId, itemId) => 
    axios.delete(`${API_URL}/document-categories/${categoryId}/items/${itemId}`),
  
  seedDefaults: () => axios.post(`${API_URL}/seed-document-categories`),
  materializeInvestmentTemplate: (investmentId) => axios.post(`${API_URL}/investments/${investmentId}/materialize-doc-template`),
};

// Audit Trail API
export const auditAPI = {
  getSettings: () => axios.get(`${API_URL}/audit/settings`),
  updateSettings: (data) => axios.put(`${API_URL}/audit/settings`, data),
  list: (params = {}) => axios.get(`${API_URL}/audit/logs`, { params }),
  getEntityHistory: (entityType, entityId) => axios.get(`${API_URL}/audit/logs/entity/${entityType}/${entityId}`),
};

// User Preferences APIs
export const userPreferencesAPI = {
  get: () => axios.get(`${API_URL}/user-preferences`),
  update: (data) => axios.put(`${API_URL}/user-preferences`, data),
};

// Distributor APIs
export const distributorAPI = {
  getAll: () => axios.get(`${API_URL}/distributors`),
  create: (data) => axios.post(`${API_URL}/distributors`, data),
  update: (id, data) => axios.put(`${API_URL}/distributors/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/distributors/${id}`),
};

// Investor Contact APIs
export const investorContactAPI = {
  getAll: () => axios.get(`${API_URL}/investor-contacts`),
  getById: (id) => axios.get(`${API_URL}/investor-contacts/${id}`),
  create: (data) => axios.post(`${API_URL}/investor-contacts`, data),
  update: (id, data) => axios.put(`${API_URL}/investor-contacts/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/investor-contacts/${id}`),
  bulkDelete: (ids) => axios.post(`${API_URL}/investor-contacts/bulk-delete`, ids),

  // Bulk import
  bulkImport: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API_URL}/investor-contacts/bulk-import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  downloadTemplate: () => axios.get(`${API_URL}/investor-contacts/bulk-import/template`, {
    responseType: 'blob',
  }),

  // Bulk update existing contacts (mirrors investor-accounts bulk-update)
  bulkUpdate: (file, mode = 'replace') => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API_URL}/investor-contacts/bulk-update?mode=${mode}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  downloadContactReferenceList: () => axios.get(`${API_URL}/investor-contacts/bulk-update/reference-list`, { responseType: 'blob' }),
  downloadBulkUpdateTemplate: () => axios.get(`${API_URL}/investor-contacts/bulk-update/template`, { responseType: 'blob' }),

  // Interaction bulk-import (Phase L4)
  bulkImportInteractions: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API_URL}/investor-contacts/bulk-import/interactions`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  downloadInteractionTemplate: () => axios.get(
    `${API_URL}/investor-contacts/bulk-import/interaction-template`,
    { responseType: 'blob' },
  ),

  // Interactions
  getInteractions: (contactId) =>
    axios.get(`${API_URL}/investor-contacts/${contactId}/interactions`),
  createInteraction: (contactId, data) =>
    axios.post(`${API_URL}/investor-contacts/${contactId}/interactions`, data),
  updateInteraction: (contactId, interactionId, data) =>
    axios.put(`${API_URL}/investor-contacts/${contactId}/interactions/${interactionId}`, data),
  deleteInteraction: (contactId, interactionId) =>
    axios.delete(`${API_URL}/investor-contacts/${contactId}/interactions/${interactionId}`),

  // Investment Summary (auto-populated from Investor Accounts)
  getInvestmentSummary: (contactId) =>
    axios.get(`${API_URL}/investor-contacts/${contactId}/investment-summary`),
};

// AMC Team Members API (for dropdowns)
export const teamAPI = {
  getMembers: () => axios.get(`${API_URL}/amc-team-members`),
};

// Urgency Rules API
export const urgencyRulesAPI = {
  get: () => axios.get(`${API_URL}/urgency-rules`),
  update: (data) => axios.put(`${API_URL}/urgency-rules`, data),
};

// Investor Account APIs
export const investorAccountAPI = {
  getAll: () => axios.get(`${API_URL}/investor-accounts`),
  getById: (id) => axios.get(`${API_URL}/investor-accounts/${id}`),
  create: (data) => axios.post(`${API_URL}/investor-accounts`, data),
  update: (id, data) => axios.put(`${API_URL}/investor-accounts/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/investor-accounts/${id}`),
  bulkDelete: (ids) => axios.post(`${API_URL}/investor-accounts/bulk-delete`, ids),
  bulkImport: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API_URL}/investor-accounts/bulk-import`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  downloadBulkImportTemplate: () => axios.get(`${API_URL}/investor-accounts/bulk-import/template`, { responseType: 'blob' }),
  // Bulk update existing accounts
  bulkUpdate: (file, mode = 'replace') => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API_URL}/investor-accounts/bulk-update?mode=${mode}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  downloadAccountReferenceList: () => axios.get(`${API_URL}/investor-accounts/bulk-update/reference-list`, { responseType: 'blob' }),
  downloadBulkUpdateTemplate: () => axios.get(`${API_URL}/investor-accounts/bulk-update/template`, { responseType: 'blob' }),

  // Global Transactions + NAV/FMV Bulk Upload
  bulkUploadTxnNav: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API_URL}/investor-accounts/bulk-upload-txn-nav`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  downloadTxnNavTemplate: () => axios.get(`${API_URL}/investor-accounts/bulk-upload-txn-nav/template`, { responseType: 'blob' }),

  // Investments
  getInvestments: (accountId) => axios.get(`${API_URL}/investor-accounts/${accountId}/investments`),
  createInvestment: (accountId, data) => axios.post(`${API_URL}/investor-accounts/${accountId}/investments`, data),
  updateInvestment: (accountId, invId, data) => axios.put(`${API_URL}/investor-accounts/${accountId}/investments/${invId}`, data),
  syncPastDrawdowns: (accountId, invId) => axios.post(`${API_URL}/investor-accounts/${accountId}/investments/${invId}/sync-past-drawdowns`),
  deleteInvestment: (accountId, invId) => axios.delete(`${API_URL}/investor-accounts/${accountId}/investments/${invId}`),

  // Transactions
  getTransactions: (accountId, fundId) => axios.get(`${API_URL}/investor-accounts/${accountId}/transactions${fundId ? `?fund_id=${fundId}` : ''}`),
  getDrawdownCalls: (accountId, fundId) => axios.get(`${API_URL}/investor-accounts/${accountId}/drawdown-calls${fundId ? `?fund_id=${fundId}` : ''}`),
  bulkApproveReceipts: (accountId, drawdownId) => axios.post(`${API_URL}/investor-accounts/${accountId}/receipts/bulk-approve`, drawdownId ? { drawdown_id: drawdownId } : {}),
  createTransaction: (accountId, data) => axios.post(`${API_URL}/investor-accounts/${accountId}/transactions`, data),
  updateTransaction: (accountId, txnId, data) => axios.put(`${API_URL}/investor-accounts/${accountId}/transactions/${txnId}`, data),
  deleteTransaction: (accountId, txnId) => axios.delete(`${API_URL}/investor-accounts/${accountId}/transactions/${txnId}`),
  bulkUploadTransactions: (accountId, data) => axios.post(`${API_URL}/investor-accounts/${accountId}/transactions/bulk`, data),
  bulkDeleteTransactions: (accountId, txnIds) => axios.post(`${API_URL}/investor-accounts/${accountId}/transactions/bulk-delete`, txnIds),

  // NAVs
  getNAVs: (accountId, fundId) => axios.get(`${API_URL}/investor-accounts/${accountId}/navs${fundId ? `?fund_id=${fundId}` : ''}`),
  createNAV: (accountId, data) => axios.post(`${API_URL}/investor-accounts/${accountId}/navs`, data),
  updateNAV: (accountId, navId, data) => axios.put(`${API_URL}/investor-accounts/${accountId}/navs/${navId}`, data),
  deleteNAV: (accountId, navId) => axios.delete(`${API_URL}/investor-accounts/${accountId}/navs/${navId}`),
  bulkUploadNAVs: (accountId, data) => axios.post(`${API_URL}/investor-accounts/${accountId}/navs/bulk`, data),

  // Documentation
  getDocSections: (accountId) => axios.get(`${API_URL}/investor-accounts/${accountId}/doc-sections`),
  createDocSection: (accountId, data) => axios.post(`${API_URL}/investor-accounts/${accountId}/doc-sections`, data),
  updateDocSection: (accountId, sectionId, data) => axios.put(`${API_URL}/investor-accounts/${accountId}/doc-sections/${sectionId}`, data),
  deleteDocSection: (accountId, sectionId) => axios.delete(`${API_URL}/investor-accounts/${accountId}/doc-sections/${sectionId}`),
  createDocItem: (accountId, sectionId, data) => axios.post(`${API_URL}/investor-accounts/${accountId}/doc-sections/${sectionId}/items`, data),
  updateDocItem: (accountId, itemId, data) => axios.put(`${API_URL}/investor-accounts/${accountId}/doc-items/${itemId}`, data),
  deleteDocItem: (accountId, itemId) => axios.delete(`${API_URL}/investor-accounts/${accountId}/doc-items/${itemId}`),
  uploadDocument: (accountId, itemId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API_URL}/investor-accounts/${accountId}/doc-items/${itemId}/upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  downloadDocument: (accountId, itemId) => axios.get(`${API_URL}/investor-accounts/${accountId}/doc-items/${itemId}/download`),

  // SOA Generation (single account)
  generateSOA: (accountId, fundId, templateId, fromDate, toDate, includeNav) => {
    const params = new URLSearchParams({ template_id: templateId });
    if (fromDate) params.append('from_date', fromDate);
    if (toDate) params.append('to_date', toDate);
    if (includeNav !== undefined) params.append('include_nav', includeNav);
    return axios.get(`${API_URL}/investor-accounts/${accountId}/funds/${fundId}/generate-soa?${params}`, { responseType: 'blob' });
  },

  // Pledged Summary
  getPledgedSummary: (accountId) => axios.get(`${API_URL}/investor-accounts/${accountId}/pledged-summary`),

  // Bank & Demat
  getBankDemat: (accountId) => axios.get(`${API_URL}/investor-accounts/${accountId}/bank-demat`),
  createBankDemat: (accountId, data) => axios.post(`${API_URL}/investor-accounts/${accountId}/bank-demat`, data),
  updateBankDemat: (accountId, recordId, data) => axios.put(`${API_URL}/investor-accounts/${accountId}/bank-demat/${recordId}`, data),
  deleteBankDemat: (accountId, recordId) => axios.delete(`${API_URL}/investor-accounts/${accountId}/bank-demat/${recordId}`),
  uploadBankDematDoc: (accountId, recordId, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API_URL}/investor-accounts/${accountId}/bank-demat/${recordId}/upload-doc`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  downloadBankDematDoc: (accountId, recordId) => axios.get(`${API_URL}/investor-accounts/${accountId}/bank-demat/${recordId}/download-doc`),

  // Nominees — list/create/update/delete + audit trail via change_history.
  getNominees: (accountId) => axios.get(`${API_URL}/investor-accounts/${accountId}/nominees`),
  createNominee: (accountId, data) => axios.post(`${API_URL}/investor-accounts/${accountId}/nominees`, data),
  updateNominee: (accountId, nomineeId, data) => axios.put(`${API_URL}/investor-accounts/${accountId}/nominees/${nomineeId}`, data),
  deleteNominee: (accountId, nomineeId) => axios.delete(`${API_URL}/investor-accounts/${accountId}/nominees/${nomineeId}`),
};

// Transaction Types Config API
export const transactionTypesAPI = {
  get: () => axios.get(`${API_URL}/transaction-types-config`),
  update: (data) => axios.put(`${API_URL}/transaction-types-config`, data),
};

// Dashboard API
export const dashboardAPI = {
  getSummary: () => axios.get(`${API_URL}/dashboard/summary`),
  getChartData: () => axios.get(`${API_URL}/dashboard/chart-data`),
};

// Fund Investors API
export const fundInvestorsAPI = {
  getByFund: (fundId) => axios.get(`${API_URL}/funds/${fundId}/investors`),
};

// Reports API
export const reportsAPI = {
  getInvestorCoverage: () => axios.get(`${API_URL}/reports/investor-coverage`),
  getInvestorCoveragePlan: () => axios.get(`${API_URL}/reports/investor-coverage-plan`),
  getFundSummary: (fundId) => axios.get(`${API_URL}/reports/fund-summary/${fundId}`),
  getAMCConsolidated: () => axios.get(`${API_URL}/reports/amc-consolidated`),
  getCustom: (columns, filters, sortByUrgency, fundId, fromDate, toDate) => axios.post(`${API_URL}/reports/custom`, { columns, filters, sort_by_urgency: sortByUrgency || false, fund_id: fundId || null, from_date: fromDate || null, to_date: toDate || null }),
  getFundSummaryCustom: (fundId, columns, filters) => axios.post(`${API_URL}/reports/fund-summary-custom/${fundId}`, { columns, filters }),
  getFieldCatalog: () => axios.get(`${API_URL}/reports/field-catalog`),
};

// Report Templates API
export const reportTemplatesAPI = {
  getAll: () => axios.get(`${API_URL}/report-templates`),
  create: (data) => axios.post(`${API_URL}/report-templates`, data),
  update: (id, data) => axios.put(`${API_URL}/report-templates/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/report-templates/${id}`),
};

// AI Certification Process API
export const aiCertificationAPI = {
  getAll: (params = {}) => {
    const qs = new URLSearchParams();
    if (params.search) qs.append('search', params.search);
    if (params.investor_type) qs.append('investor_type', params.investor_type);
    if (params.kyc_status) qs.append('kyc_status', params.kyc_status);
    if (params.cdsl_status) qs.append('cdsl_status', params.cdsl_status);
    if (params.ai_app_status) qs.append('ai_app_status', params.ai_app_status);
    if (params.ai_cert_status) qs.append('ai_cert_status', params.ai_cert_status);
    if (params.invoicing_status) qs.append('invoicing_status', params.invoicing_status);
    if (params.page) qs.append('page', params.page);
    if (params.page_size) qs.append('page_size', params.page_size);
    return axios.get(`${API_URL}/ai-certifications?${qs.toString()}`);
  },
  getById: (id) => axios.get(`${API_URL}/ai-certifications/${id}`),
  create: (data) => axios.post(`${API_URL}/ai-certifications`, data),
  update: (id, data) => axios.put(`${API_URL}/ai-certifications/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/ai-certifications/${id}`),
  updateActivity: (id, data) => axios.put(`${API_URL}/ai-certifications/${id}/activity`, data),
  bulkDelete: (ids) => axios.post(`${API_URL}/ai-certifications/bulk-delete`, ids),
  getInvestorTypes: () => axios.get(`${API_URL}/ai-certifications/config/investor-types`),
  addInvestorType: (typeName) => axios.post(`${API_URL}/ai-certifications/config/investor-types`, { type_name: typeName }),
  deleteInvestorType: (typeName) => axios.delete(`${API_URL}/ai-certifications/config/investor-types/${encodeURIComponent(typeName)}`),
  // Bulk import
  downloadBulkTemplate: () => axios.get(`${API_URL}/ai-certifications/bulk-import/template`, { responseType: 'blob' }),
  bulkImport: (formData) => axios.post(`${API_URL}/ai-certifications/bulk-import`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  // Import from Investor Accounts
  getAvailableAccounts: (search) => axios.get(`${API_URL}/ai-certifications/import-from-accounts/available${search ? `?search=${encodeURIComponent(search)}` : ''}`),
  importFromAccounts: (accountIds) => axios.post(`${API_URL}/ai-certifications/import-from-accounts`, { account_ids: accountIds }),
  getExportRoles: () => axios.get(`${API_URL}/ai-certifications/config/export-roles`),
  updateExportRoles: (roles) => axios.put(`${API_URL}/ai-certifications/config/export-roles`, { roles }),
  exportData: (format, params = {}) => {
    const qs = new URLSearchParams({ format });
    if (params.search) qs.append('search', params.search);
    if (params.investor_type) qs.append('investor_type', params.investor_type);
    if (params.kyc_status) qs.append('kyc_status', params.kyc_status);
    if (params.cdsl_status) qs.append('cdsl_status', params.cdsl_status);
    if (params.ai_app_status) qs.append('ai_app_status', params.ai_app_status);
    if (params.ai_cert_status) qs.append('ai_cert_status', params.ai_cert_status);
    if (params.invoicing_status) qs.append('invoicing_status', params.invoicing_status);
    return axios.get(`${API_URL}/ai-certifications/export?${qs.toString()}`, { responseType: 'blob' });
  },
};


export const dataRoomAPI = {
  list: (params = {}) => {
    const qs = new URLSearchParams();
    if (params.investment_id) qs.append('investment_id', params.investment_id);
    if (params.status) qs.append('status', params.status);
    return axios.get(`${API_URL}/data-rooms?${qs.toString()}`);
  },
  get: (id) => axios.get(`${API_URL}/data-rooms/${id}`),
  create: (data) => axios.post(`${API_URL}/data-rooms`, data),
  update: (id, data) => axios.put(`${API_URL}/data-rooms/${id}`, data),
  remove: (id) => axios.delete(`${API_URL}/data-rooms/${id}`),
  listFolders: (id) => axios.get(`${API_URL}/data-rooms/${id}/folders`),
  createFolder: (id, data) => axios.post(`${API_URL}/data-rooms/${id}/folders`, data),
  updateFolder: (id, folderId, data) => axios.put(`${API_URL}/data-rooms/${id}/folders/${folderId}`, data),
  reorderFolders: (id, updates) => axios.post(`${API_URL}/data-rooms/${id}/folders/reorder`, { updates }),
  deleteFolder: (id, folderId) => axios.delete(`${API_URL}/data-rooms/${id}/folders/${folderId}`),
  listFiles: (id, folderId) => {
    const qs = folderId != null ? `?folder_id=${folderId}` : '';
    return axios.get(`${API_URL}/data-rooms/${id}/files${qs}`);
  },
  uploadFile: (id, file, folderId, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    if (folderId) form.append('folder_id', folderId);
    return axios.post(`${API_URL}/data-rooms/${id}/files`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress,
    });
  },
  renameFile: (id, fileId, data) => axios.put(`${API_URL}/data-rooms/${id}/files/${fileId}`, data),
  deleteFile: (id, fileId) => axios.delete(`${API_URL}/data-rooms/${id}/files/${fileId}`),
  getDownloadUrl: (id, fileId, config = {}) => axios.get(`${API_URL}/data-rooms/${id}/files/${fileId}/download-url`, config),
  listFileVersions: (id, fileId) => axios.get(`${API_URL}/data-rooms/${id}/files/${fileId}/versions`),
  listRoles: (id) => axios.get(`${API_URL}/data-rooms/${id}/roles`),
  createRole: (id, data) => axios.post(`${API_URL}/data-rooms/${id}/roles`, data),
  updateRole: (id, roleId, data) => axios.put(`${API_URL}/data-rooms/${id}/roles/${roleId}`, data),
  deleteRole: (id, roleId) => axios.delete(`${API_URL}/data-rooms/${id}/roles/${roleId}`),
  listExternalUsers: (id) => axios.get(`${API_URL}/data-rooms/${id}/external-users`),
  inviteExternalUser: (id, data) => axios.post(`${API_URL}/data-rooms/${id}/external-users`, data),
  updateExternalUser: (id, userId, data) => axios.put(`${API_URL}/data-rooms/${id}/external-users/${userId}`, data),
  revokeExternalUser: (id, userId) => axios.post(`${API_URL}/data-rooms/${id}/external-users/${userId}/revoke`),
  reinstateExternalUser: (id, userId) => axios.post(`${API_URL}/data-rooms/${id}/external-users/${userId}/reinstate`),
  deleteExternalUser: (id, userId) => axios.delete(`${API_URL}/data-rooms/${id}/external-users/${userId}`),
  listInternalMembers: (id) => axios.get(`${API_URL}/data-rooms/${id}/internal-members`),
  tagInternalMember: (id, data) => axios.post(`${API_URL}/data-rooms/${id}/internal-members`, data),
  untagInternalMember: (id, memberId) => axios.delete(`${API_URL}/data-rooms/${id}/internal-members/${memberId}`),
  availableAmcUsers: (id) => axios.get(`${API_URL}/data-rooms/${id}/available-amc-users`),
  listPermissions: (id) => axios.get(`${API_URL}/data-rooms/${id}/permissions`),
  setPermission: (id, data) => axios.post(`${API_URL}/data-rooms/${id}/permissions`, data),
  deletePermission: (id, permissionId) => axios.delete(`${API_URL}/data-rooms/${id}/permissions/${permissionId}`),
  getMatrix: (id) => axios.get(`${API_URL}/data-rooms/${id}/permissions/matrix`),
  getFileMatrix: (id, folderId = null) => {
    const qs = folderId != null ? `?folder_id=${encodeURIComponent(folderId)}` : '';
    return axios.get(`${API_URL}/data-rooms/${id}/permissions/file-matrix${qs}`);
  },
  flagHighValue: (id, fileId, isHighValue) =>
    axios.post(`${API_URL}/data-rooms/${id}/files/${fileId}/flag-high-value`, { is_high_value: isHighValue }),
  getPreviewInfo: (id, fileId, config = {}) =>
    axios.get(`${API_URL}/data-rooms/${id}/files/${fileId}/preview-info`, config),
  previewPdfUrl: (id, fileId) => `${API_URL}/data-rooms/${id}/files/${fileId}/preview.pdf`,
  previewPageUrl: (id, fileId, page) => `${API_URL}/data-rooms/${id}/files/${fileId}/preview/page/${page}.png`,
  recordViewEvent: (id, fileId, payload, config = {}) =>
    axios.post(`${API_URL}/data-rooms/${id}/files/${fileId}/view-event`, payload, config),
  recordPrintAttempt: (id, fileId, config = {}) =>
    axios.post(`${API_URL}/data-rooms/${id}/files/${fileId}/print-attempt`, null, config),
  listAuditLogs: (id, params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => v != null && v !== '' && qs.append(k, v));
    return axios.get(`${API_URL}/data-rooms/${id}/audit-logs?${qs.toString()}`);
  },
  activitySummary: (id) => axios.get(`${API_URL}/data-rooms/${id}/activity-summary`),
  exportAuditLogsXlsx: (id) => `${API_URL}/data-rooms/${id}/audit-logs/export.xlsx`,
  listQuestions: (id, params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => v != null && v !== '' && qs.append(k, v));
    return axios.get(`${API_URL}/data-rooms/${id}/qa/questions?${qs.toString()}`);
  },
  createQuestion: (id, data) => axios.post(`${API_URL}/data-rooms/${id}/qa/questions`, data),
  getTaggableUsers: (id) => axios.get(`${API_URL}/data-rooms/${id}/qa/taggable-users`),
  getQuestion: (id, questionId) => axios.get(`${API_URL}/data-rooms/${id}/qa/questions/${questionId}`),
  updateQuestion: (id, questionId, data) => axios.put(`${API_URL}/data-rooms/${id}/qa/questions/${questionId}`, data),
  deleteQuestion: (id, questionId) => axios.delete(`${API_URL}/data-rooms/${id}/qa/questions/${questionId}`),
  createAnswer: (id, questionId, data) => axios.post(`${API_URL}/data-rooms/${id}/qa/questions/${questionId}/answers`, data),
  updateAnswer: (id, answerId, data) => axios.put(`${API_URL}/data-rooms/${id}/qa/answers/${answerId}`, data),
  deleteAnswer: (id, answerId) => axios.delete(`${API_URL}/data-rooms/${id}/qa/answers/${answerId}`),
  search: (id, q) => axios.get(`${API_URL}/data-rooms/${id}/search?q=${encodeURIComponent(q)}`),
  updateFileTags: (id, fileId, tags) => axios.put(`${API_URL}/data-rooms/${id}/files/${fileId}/tags`, { tags }),
  multipartInit: (id, data) => axios.post(`${API_URL}/data-rooms/${id}/files/multipart/init`, data),
  multipartPartUrl: (id, uploadId, part) =>
    axios.get(`${API_URL}/data-rooms/${id}/files/multipart/${uploadId}/part-url?part=${part}`),
  multipartComplete: (id, uploadId, parts) =>
    axios.post(`${API_URL}/data-rooms/${id}/files/multipart/${uploadId}/complete`, { parts }),
  multipartAbort: (id, uploadId) =>
    axios.post(`${API_URL}/data-rooms/${id}/files/multipart/${uploadId}/abort`),
  externalVerify: (token) =>
    axios.post(`${API_URL}/data-rooms/external-auth/verify`, { token }, { transformRequest: [(d) => JSON.stringify(d)], headers: { 'Content-Type': 'application/json' } }),
  externalMe: (jwt) => axios.get(`${API_URL}/data-rooms/external-auth/me`, { headers: { Authorization: `Bearer ${jwt}` } }),
  externalFolders: (jwt) => axios.get(`${API_URL}/data-rooms/external-auth/list-folders`, { headers: { Authorization: `Bearer ${jwt}` } }),
  externalFiles: (jwt, folderId) => {
    const qs = folderId != null ? `?folder_id=${folderId}` : '';
    return axios.get(`${API_URL}/data-rooms/external-auth/list-files${qs}`, { headers: { Authorization: `Bearer ${jwt}` } });
  },
  // External Q&A
  externalListQuestions: (jwt) => axios.get(`${API_URL}/data-rooms/external-auth/qa/questions`, { headers: { Authorization: `Bearer ${jwt}` } }),
  externalCreateQuestion: (jwt, data) => axios.post(`${API_URL}/data-rooms/external-auth/qa/questions`, data, { headers: { Authorization: `Bearer ${jwt}`, 'Content-Type': 'application/json' } }),
  externalGetQuestion: (jwt, questionId) => axios.get(`${API_URL}/data-rooms/external-auth/qa/questions/${questionId}`, { headers: { Authorization: `Bearer ${jwt}` } }),
  externalGetAssignableMembers: (jwt) => axios.get(`${API_URL}/data-rooms/external-auth/qa/assignable-members`, { headers: { Authorization: `Bearer ${jwt}` } }),
};


// Compliance Tracker APIs
export const complianceAPI = {
  // Sections
  listSections: () => axios.get(`${API_URL}/compliance/sections`),
  createSection: (data) => axios.post(`${API_URL}/compliance/sections`, data),
  updateSection: (id, data) => axios.put(`${API_URL}/compliance/sections/${id}`, data),
  deleteSection: (id) => axios.delete(`${API_URL}/compliance/sections/${id}`),
  // Section-level reference documents (AWS object storage)
  uploadSectionDocument: (sectionId, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API_URL}/compliance/sections/${sectionId}/documents`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  previewSectionDocumentUrl: (sectionId, docId) => `${API_URL}/compliance/sections/${sectionId}/documents/${docId}/preview`,
  deleteSectionDocument: (sectionId, docId) => axios.delete(`${API_URL}/compliance/sections/${sectionId}/documents/${docId}`),
  // Item-level reference documents
  uploadItemDocument: (itemId, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API_URL}/compliance/items/${itemId}/documents`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  previewItemDocumentUrl: (itemId, docId) => `${API_URL}/compliance/items/${itemId}/documents/${docId}/preview`,
  deleteItemDocument: (itemId, docId) => axios.delete(`${API_URL}/compliance/items/${itemId}/documents/${docId}`),

  // Items
  listItems: (section_id) => {
    const qs = section_id ? `?section_id=${section_id}` : '';
    return axios.get(`${API_URL}/compliance/items${qs}`);
  },
  getItem: (id) => axios.get(`${API_URL}/compliance/items/${id}`),
  createItem: (data) => axios.post(`${API_URL}/compliance/items`, data),
  updateItem: (id, data) => axios.put(`${API_URL}/compliance/items/${id}`, data),
  deleteItem: (id) => axios.delete(`${API_URL}/compliance/items/${id}`),
  // Adhoc (fund-specific) items — stay out of the shared database.
  createAdhocItem: (data) => axios.post(`${API_URL}/compliance/adhoc-items`, data),
  downloadItemTemplate: () => axios.get(`${API_URL}/compliance/items/bulk-import/template`, { responseType: 'blob' }),
  bulkImportItems: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API_URL}/compliance/items/bulk-import`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  // Fund assignments
  getFundAssignments: (fundId) => axios.get(`${API_URL}/compliance/funds/${fundId}/assignments`),
  saveFundAssignments: (fundId, rows, section_rows = []) =>
    axios.put(`${API_URL}/compliance/funds/${fundId}/assignments`, { rows, section_rows }),
  listPendingEvents: (fundId) => axios.get(`${API_URL}/compliance/funds/${fundId}/pending-events`),

  // Occurrences
  listOccurrences: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') qs.append(k, v);
    });
    return axios.get(`${API_URL}/compliance/occurrences${qs.toString() ? `?${qs}` : ''}`);
  },
  getOccurrence: (id) => axios.get(`${API_URL}/compliance/occurrences/${id}`),
  updateOccurrence: (id, data) => axios.put(`${API_URL}/compliance/occurrences/${id}`, data),
  claimOccurrence: (id) => axios.post(`${API_URL}/compliance/occurrences/${id}/claim`),
  uploadDocument: (occId, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API_URL}/compliance/occurrences/${occId}/documents`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  previewDocumentUrl: (occId, docId) => `${API_URL}/compliance/occurrences/${occId}/documents/${docId}/preview`,
  deleteDocument: (occId, docId) => axios.delete(`${API_URL}/compliance/occurrences/${occId}/documents/${docId}`),

  // Email triggers
  listEmailTriggers: () => axios.get(`${API_URL}/compliance/email-triggers`),
  saveEmailTrigger: (data) => axios.post(`${API_URL}/compliance/email-triggers`, data),
  sendEmailTriggerNow: (id, data = {}) => axios.post(`${API_URL}/compliance/email-triggers/${id}/send-now`, data),
  listComplianceRecipients: () => axios.get(`${API_URL}/compliance-recipients`),

  // Team
  listTeamMembers: () => axios.get(`${API_URL}/compliance/team-members`),

  // Bulk assign
  bulkAssign: (occurrence_ids, assignee_id) =>
    axios.put(`${API_URL}/compliance/occurrences/bulk-assign`, { occurrence_ids, assignee_id: assignee_id || null }),

  // Reassignment
  listReassignments: () => axios.get(`${API_URL}/compliance/reassignment-requests`),
  pendingReassignmentCount: () => axios.get(`${API_URL}/compliance/reassignment-requests/pending-count`),
  createReassignment: (data) => axios.post(`${API_URL}/compliance/reassignment-requests`, data),
  decideReassignment: (id, data) => axios.post(`${API_URL}/compliance/reassignment-requests/${id}/decision`, data),
  bulkTransferAssignee: (data) => axios.post(`${API_URL}/compliance/reassignments/bulk-transfer`, data),
  bulkTransferHistory: () => axios.get(`${API_URL}/compliance/reassignments/bulk-transfer/history`),

  // Reports
  previewReport: (params) => {
    const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v));
    return axios.get(`${API_URL}/compliance/reports/preview?${qs}`);
  },
  exportReportUrl: (params) => {
    const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v));
    return `${API_URL}/compliance/reports/export?${qs}`;
  },
  downloadReport: (params) => {
    const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v));
    return axios.get(`${API_URL}/compliance/reports/export?${qs}`, { responseType: 'blob' });
  },
};

export const scheduleK1ReportAPI = {
  catalog: () => axios.get(`${API_URL}/reports/schedule-k1/catalog`),
  get: ({ fundId, columns }) => axios.post(`${API_URL}/reports/schedule-k1`, { fund_id: fundId || null, columns }),
};

export const dematAPI = {
  getMapping: () => axios.get(`${API_URL}/demat/mapping`),
  parse: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API_URL}/demat/benpos/parse`, fd);
  },
  upload: ({ file, fundId, asOnDate, mapping, remarks }) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('fund_id', fundId);
    fd.append('as_on_date', asOnDate);
    fd.append('mapping', JSON.stringify(mapping));
    fd.append('remarks', remarks || '');
    return axios.post(`${API_URL}/demat/benpos/uploads`, fd);
  },
  list: (fundId) => axios.get(`${API_URL}/demat/benpos/uploads${fundId ? `?fund_id=${fundId}` : ''}`),
  remove: (id) => axios.delete(`${API_URL}/demat/benpos/uploads/${id}`),
  downloadFile: (id) => axios.get(`${API_URL}/demat/benpos/uploads/${id}/file`, { responseType: 'blob' }),
  reconciliation: (id) => axios.get(`${API_URL}/demat/benpos/uploads/${id}/reconciliation`),
  accountFieldCatalog: () => axios.get(`${API_URL}/demat/account-field-catalog`),
  accountFields: (id, columns, accountIds) => axios.post(`${API_URL}/demat/benpos/uploads/${id}/account-fields`, { columns, account_ids: accountIds }),
};
